<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="spkb"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="spkbForm"
          :redirect-detail="true"
          :custom-variable-id="'spkb_number'"
          :show-add-button="false"
          caption="<i class='fa fa-align-justify'></i> SPKB Listing"
        ></global-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";
import globalTable from "../../templates/Table.vue";
import loading from "@/templates/Loading.vue";

export default {
  name: "spkb",
  components: {
    globalTable,
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      spkb: [],
      loading: true,
      spkbForm: interfaces.spkb,
      fields: [
        { key: "spkb_number", sortable: true },
        { key: "driver_name", label: "Nama Supir" },
        { key: "penanggung_jawab_faktur", label: "Penanggung Jawab Faktur" },
        { key: "total_price_plan", label: "Total SPKB" },
        { key: "delivery_date", label: "Tanggal Pengiriman" },
        { key: "action", label: "Action", class: "text-center width-100" }
      ],
      show_dc: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getAllSpkb();
    },
    getAllSpkb: function() {
      this.axios
        .get("mobile/dashboard/inventory/spkb-list/0/")
        .then(response => {
          this.spkb = response.data.data;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(a) {
      this.resetForm();
      this.spkbForm = a;
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>